import { type FieldValues, type Path, type UseFormProps, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useUpdateEffect } from 'ahooks';

export function useLidForm<TFieldValues extends FieldValues = FieldValues>(props?: UseFormProps<TFieldValues>) {
  const formData = useForm<TFieldValues>(props);
  const {
    setError: setFormError,
    formState: { errors },
    trigger,
  } = formData;
  const { i18n } = useTranslation();

  const setError = (value: Path<TFieldValues>, errorMessage: string) => {
    setFormError(value, { message: errorMessage }, { shouldFocus: true });
  };

  useUpdateEffect(() => {
    const keys = Object.keys(errors);
    if (keys.length > 0) trigger(keys as Path<TFieldValues>[]);
  }, [i18n.language]);

  return {
    ...formData,
    setError,
  };
}
